<template>
	<div id="im-abogado-page" data-aos="fade">
		<!-- Hero -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<p class="hero-eyebrow" data-aos="fade-up">Soy abogado</p>
						<h1 class="hero-title" data-aos="fade-up" data-aos-delay="50">Únete a la revolución legal</h1>
						<p class="hero-lead" data-aos="fade-up" data-aos-delay="100">
							Forma parte del equipo de abogados que está transformando la industria legal en México
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Beneficios -->
		<section class="benefits-section">
			<div class="container">
				<div class="row mb-4 mb-md-5">
					<div class="col-12 text-center">
						<h2 class="section-title" data-aos="fade-up" data-aos-delay="150">¿Cómo funciona mi afiliación?</h2>
						<p class="section-lead" data-aos="fade-up" data-aos-delay="150">
							Descubre los beneficios exclusivos que obtienes al unirte a unlawk
						</p>
					</div>
				</div>

				<div class="row justify-content-center">
					<div
						v-for="benefit in benefits"
						:key="benefit.id"
						class="col-sm-6 col-lg-3 mb-4"
						:data-aos="benefit.aosAnimation"
						:data-aos-delay="benefit.aosDelay"
					>
						<div class="benefit-card h-100 d-flex flex-column align-items-center text-center">
							<div
								class="benefit-icon"
								:class="benefit.iconVariant"
							>
								<i :class="benefit.icon"></i>
							</div>
							<h3 class="benefit-title">{{ benefit.title }}</h3>
							<p class="benefit-text">{{ benefit.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- CTA -->
		<section class="cta-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-8 mx-auto text-center">
						<h2 class="cta-title" data-aos="fade-up">¿Listo para unirte a unlawk?</h2>
						<p class="cta-lead" data-aos="fade-up" data-aos-delay="100">
							Completa tu solicitud de afiliación y comienza a recibir clientes calificados
						</p>
						<div data-aos="fade-up" data-aos-delay="150">
							<b-button
								to="/afiliacion/solicitud"
								variant="danger"
								size="lg"
								class="cta-btn"
							>
								<i class="fa-regular fa-user-plus mr-2"></i>
								Solicitar Afiliación Ahora
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			benefits: [
				{
					id: 'leads',
					aosAnimation: 'fade-up',
					icon: 'fa-regular fa-users',
					iconVariant: 'benefit-icon--navy',
					title: 'Tendrás leads de clientes',
					text: 'Recibe clientes potenciales directamente en tu perfil, sin necesidad de buscar activamente nuevos casos.',
				},
				{
					id: 'ia',
					aosAnimation: 'fade-down',
					aosDelay: 50,
					icon: 'fa-regular fa-messages',
					iconVariant: 'benefit-icon--navy',
					title: 'Consultarás su plática con la IA',
					text: 'Accede al historial completo de la conversación del cliente con nuestra IA para entender mejor su caso.',
				},
				{
					id: 'rapidez',
					aosAnimation: 'fade-up',
					aosDelay: 100,
					icon: 'fa-regular fa-bolt',
					iconVariant: 'benefit-icon--primary',
					title: 'Tu atención será más rápida',
					text: 'Con información previa del caso, podrás brindar asesoría más eficiente y enfocada desde el primer contacto.',
				},
				{
					id: 'directorio',
					aosAnimation: 'fade-down',
					aosDelay: 150,
					icon: 'fa-regular fa-eye',
					iconVariant: 'benefit-icon--primary',
					title: 'Aparecerás en un directorio con tráfico',
					text: 'Tu perfil será visible en nuestro directorio de abogados, recibiendo exposición constante a nuevos clientes.',
				},
			],
		}
	},
}
</script>
